import { HOURS_FETCH_REQUEST, HOURS_FETCH_SUCCESS, HOURS_FETCH_FAILURE } from './types';
import baseUrl from '../url'

const fetchHoursRequest = () => {
    return {
        type: HOURS_FETCH_REQUEST
    }
}

export const fetchHoursSuccess = hours => {
    return {
        type: HOURS_FETCH_SUCCESS,
        payload: hours,
    }
}

const fetchHoursFailure = error => {
    return {
        type: HOURS_FETCH_FAILURE,
        payload: error,
    }
}


export const getHours = (slug, date) => {
    return (dispatch) => {
        dispatch(fetchHoursRequest());
        fetch(`${baseUrl}/available_hours/${slug}?date=${date}`, {
                method: 'GET'
            })
            .then(response => response.json())
            .then((response) => {
                dispatch(fetchHoursSuccess(response));
            })
            .catch((error) => {
                dispatch(fetchHoursFailure(error.message));
            })
    }
}